<template>
  <div class="mlr birthday-wrap mb-24">
    <el-tooltip
      v-for="(item, accessoryIndex) in accessoryItems"
      :id="accessoryIndex"
      :key="item.id"
      effect="light"
      :content="item.tip"
      placement="top-start"
    >
      <div
        :class="{'part-item': true, active: checked && accessoryIndex === 0 || accessoryIndex >=1 }"
        @click="handleCheck(accessoryIndex)"
      >
        {{ item.name }}
      </div>
    </el-tooltip>
    <div v-if="checked">
      <!-- 诺心只有一个标签 placeholder 只取一个 -->
      <el-input
        id="userRemark"
        v-model="input"
        :placeholder="accessoryItems[0].placeholder"
        maxlength="28"
        @input="setAccessoryUserRemark"
      ></el-input>
    </div>

    <div
      v-if="warnTextShow && checked"
      class="check-warn"
    >
      <i class="el-icon-warning"></i>
      <span>{{TLang('最多14个汉字或者28个字母','list')}}</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Nuoxin',
  props: {
    accessoryItems: Array,
  },
  data() {
    return {
      input: '',
      checked: false,
      warnTextShow: false,
    };
  },
  watch: {
    checked: function(check){
      if(!check){
        this.input = '';
        this.$emit('setAccessory',undefined);
      }
    },
  },
  mounted(){
    document.getElementById('create-order').addEventListener('click',this.handleCreate, false);
  },
  methods: {
    setAccessoryUserRemark(value) {
      // let name = '';
      let strLen = 0;

      // 替换 html 代码
      this.input = value.replace(/<.*>/g, '');

      // 替换是否存在表情
      this.input = this.input.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, '');

      // 多个空格替换为一个空格
      this.input = this.input.replace(/\s+/g, ' ');
      this.input = this.input.replace(/\(+/g, '（');
      this.input = this.input.replace(/\)+/g, '）');

      const regEn = /[`~@#$%^&*()_+<>?:"{},./;'[]]/g;
      const regCn = /[·#￥（——）：；“”‘、|《》？、【】[]]/g;

      this.input = this.input.replace(regEn, '');
      this.input = this.input.replace(regCn, '');
      //只能输入，。！？（）因为字母/数组/中文
      this.input = this.input.replace(/[^，。！？（）,.?!()a-zA-Z0-9\u4e00-\u9fa5]/g,'');
      
      for (let i = 0; i < this.input.length; i++) {
        if (this.input.charCodeAt(i) < 27 || this.input.charCodeAt(i) > 126) {
          strLen += 2;
        } else {
          strLen++;
        }
        if (strLen > 28) {
          this.input = this.input.substring(0, i);
          return;
        }
        this.warnTextShow = strLen >= 28;
      }
      if(this.input){
        this.$emit('setAccessory','('+ this.input +')');
      }
    },
    handleCheck(index){
      if(index === 0){
        this.checked = !this.checked;
      }
    },
    handleCreate(){
      if(this.checked && !this.input){
        this.$emit('setAccessory','(生日快乐)');
      }
    },
  },
};
</script>

<style lang="less">
.birthday-wrap{
  .notice {
    padding: 8px;
    background:#FDECEC;
    border-radius:2px;
    font-size:12px;
  
    font-weight:400;
    color:#F44545;
    position: relative;
    margin: 0;
    &::before {
      content: '';
      border: solid 4px;
      border-top-color: transparent;
      border-left-color: transparent;
      border-right-color: #FDECEC;
      border-bottom-color: transparent;
      position: absolute;
      top: 14px;
      left: -8px;
    }

    img {
      width: 12px;
      height: 13px;
      vertical-align: top;
    }
  }
  .check-warn{
    font-size:12px;
  
    color:rgba(244,69,69,1);
    margin-top: 10px;
  }
}

.tag {
  display: inline-block;
  padding: 8px 12px;
  // margin: 0 12px 12px 0;
  margin-bottom: 12px;
  border-radius:2px;
  font-size:14px;

  background-color:#FAFAFA;
  color: #333333;

  &-checked  {
    color: #3D96E2!important;
    background:#ECF5FD!important;
    position: relative;
      &::before {
        content: "√";
        color: #fff;
        position: absolute;
        right: 0;
        top: 16px;
        z-index: 2;
      }
      &::after {
        content: "";
        width: 0;
        height: 0;
        position: absolute;
        right: 0;
        bottom: 0;
        border-width: 9px;
        border-style: solid;
        border-color: transparent #3d96e2 #3d96e2 transparent;
    }
  }
}

.line-dashed {
  width: 100%;
  border:1px dashed rgba(229,229,229,1);
}

.text-area {
  border: solid 1px#E5E5E5;
}

.el-tooltip__popper {
  padding: 8px 12px;
  margin: 0 12px 12px 0;
  border-radius:2px;
  font-size:14px;

}

.el-tooltip__popper.is-light {
  border: transparent!important;
  color: #3D96E2;
  background:#ECF5FD;

  .popper__arrow {
    border: transparent;
  }
}

.el-button {
  border: none;
  max-width: 100%;
  white-space: normal;
  word-break: break-word;
  text-align: left;
  .tag;

  span {
    border-radius:2px;
    font-size:14px;
  
    transform: scale(1);
  }
}

.el-button:focus, .el-button:hover {
  background-color:#FAFAFA;
  color: #333333;
  border-color: transparent;
}

.db {
   display: block;
}

.dn {
  display: none;
}

.birthday-wrap .el-input__inner {
  width:860px;
  height:36px;
  color: #333;
  border-radius: 0;
  background:rgba(255,255,255,1);
  border:1px solid rgba(229,229,229,1);

  ::placeholder {
    color: #f90;
  }
}
.birthday-wrap{
  overflow: hidden;
  .part-item{
    float: left;
    background:rgba(255,255,255,1);
    border:1px solid rgba(229,229,229,1);
    padding: 0 18px;
    height:40px;
    line-height: 40px;
    font-size:14px;
  
    color:rgba(51,51,51,1);
    margin-right: 20px;
    margin-bottom: 20px;
    &:hover{
      cursor: pointer;
    }
  }
  .part-item.active{
    position: relative;
    border-color: #3D96E2;
    border-width: 2px;
    &::before{
      content: "√";
      color: #fff;
      position: absolute;
      right: -7px;
      top: 14px;
      z-index: 2;
      font-weight: 500;
    }
    &::after{
      content: "";
      width: 0;
      height: 0;
      position: absolute;
      right: 0;
      bottom: 0;
      border-width: 9px;
      border-style: solid;
      border-color: #fff #3d96e2 #3d96e2 #fff;
    }
  }



}
</style>